/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useEffect } from "react";

import { usePlayerCallbacks } from "../../shared/context/PlayerCallbacksContext";
import { usePlayerTranslation } from "../../shared/context/PlayerTranslationContext";
import { usePlayerController, UserPlayerErrorMessage } from "../BasePlayer";

export const usePlayerErrorHandler = (
  onError: (error: UserPlayerErrorMessage) => void,
) => {
  const { player } = usePlayerController();
  const { t } = usePlayerTranslation();
  const { onError: onErrorCallback } = usePlayerCallbacks();

  useEffect(() => {
    const unsubscribe = player.onEvent("custom-error", (e: any) => {
      if (e?.messageKey) {
        onError({
          type: "MEDIA_ERR_CUSTOM",
          message: t(e?.messageKey) || e.message,
        });

        return;
      }

      const error = player.error();

      if (error) {
        onErrorCallback?.(error);
        onError({
          type: error.type,
          message: t(`PLAYER_ERROR_${error.type}`),
        });
      }
    });

    return () => unsubscribe();
  }, [onError, onErrorCallback, player, t]);

  return {};
};
